import { queryParamsInitial } from './data';
import { setSearchParamsToState } from './utils';
import {
  getFiltersFromSearchParams,
  setFilterParamsToSearchParams,
  setSortParamsToSearchParams,
} from '@/utils';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useTableQueryParams = (initial = queryParamsInitial) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState({
    ...initial,
    filters: getFiltersFromSearchParams(Object.fromEntries([...searchParams])),
  });

  useEffect(() => {
    setSearchParamsToState(searchParams, setQueryParams, initial);
  }, [searchParams]);

  const onPageChange = (page, size) => {
    searchParams.set('page', String(page));
    searchParams.set('pageSize', String(size));
    setSearchParams(searchParams, { replace: true });
  };

  const onSortingChange = (sortArray) => {
    searchParams.set('page', String(initial.page));
    setSortParamsToSearchParams(sortArray, searchParams);
    setSearchParams(searchParams, { replace: true });
  };

  const onFiltersChange = (filterList) => {
    searchParams.set('page', String(initial.page));
    setFilterParamsToSearchParams(filterList, searchParams);
    setSearchParams(searchParams, { replace: true });
  };

  return {
    searchParams,
    setSearchParams,
    queryParams,
    onPageChange,
    onSortingChange,
    onFiltersChange,
  };
};
